<template>
  <v-app class="opd-app">
    <v-app-bar app flat height="74" class="layanan-header">
      <div class="header-inner">
        <v-btn icon class="back-btn" @click="$router.back()" aria-label="Kembali">
          <v-icon> mdi-arrow-left </v-icon>
        </v-btn>

        <div class="header-brand">
          <div class="brand-mark">
            <img src="/images/icon2.png" width="40" alt="Bondowoso Berkah" />
          </div>

          <div class="brand-copy">
            <div class="brand-name">
              BONDOWOSO
              <span>BERKAH</span>
            </div>

            <div class="brand-tagline">Berkualitas, Akseleratif dan Holistik</div>
          </div>
        </div>

        <v-spacer />

        <div class="header-info d-none d-sm-flex">
          <div class="header-info-icon">
            <v-icon size="18" color="#018c74"> mdi-domain </v-icon>
          </div>

          <div>
            <div class="header-info-title">Daftar OPD</div>

            <div class="header-info-subtitle">Organisasi Perangkat Daerah</div>
          </div>
        </div>
      </div>
    </v-app-bar>

    <v-main class="main-area">
      <v-container fluid class="main-container">
        <div class="content-wrapper">
          <section class="directory-hero">
            <div class="hero-content">
              <div class="hero-eyebrow">
                <span class="hero-dot"></span>

                DIREKTORI PEMERINTAH KABUPATEN BONDOWOSO
              </div>

              <h1 class="hero-title">
                Daftar
                <span>OPD</span>
              </h1>

              <p class="hero-description">
                Temukan informasi organisasi perangkat daerah, lokasi kantor, serta kanal
                komunikasi resmi Pemerintah Kabupaten Bondowoso.
              </p>

              <div class="hero-actions">
                <div class="hero-mini-stat">
                  <div class="mini-stat-icon">
                    <v-icon size="18"> mdi-office-building-outline </v-icon>
                  </div>

                  <div>
                    <strong>
                      {{ listOpd.length }}
                    </strong>

                    <span> Organisasi </span>
                  </div>
                </div>

                <div class="hero-mini-stat">
                  <div class="mini-stat-icon gold">
                    <v-icon size="18"> mdi-map-marker-outline </v-icon>
                  </div>

                  <div>
                    <strong>
                      {{ filteredOpd.length }}
                    </strong>

                    <span> Ditampilkan </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="hero-visual">
              <div class="visual-circle circle-1"></div>

              <div class="visual-circle circle-2"></div>

              <div class="visual-building">
                <v-icon size="72"> mdi-domain </v-icon>
              </div>

              <div class="visual-floating-card card-top">
                <v-icon size="16" color="#018c74"> mdi-check-decagram </v-icon>

                <span> Instansi Resmi </span>
              </div>

              <div class="visual-floating-card card-bottom">
                <v-icon size="16" color="#018c74"> mdi-map-marker </v-icon>

                <span> Lokasi OPD </span>
              </div>
            </div>
          </section>

          <section class="directory-container">
            <div class="directory-toolbar">
              <div class="toolbar-heading">
                <div class="toolbar-icon">
                  <v-icon size="21"> mdi-format-list-bulleted-square </v-icon>
                </div>

                <div>
                  <div class="toolbar-kicker">DIREKTORI INSTANSI</div>

                  <h2>Seluruh OPD</h2>

                  <p>Informasi organisasi perangkat daerah Kabupaten Bondowoso</p>
                </div>
              </div>

              <div class="toolbar-total">
                <div class="toolbar-total-number">
                  {{ listOpd.length }}
                </div>

                <div>
                  <div class="toolbar-total-label">TOTAL</div>

                  <div class="toolbar-total-text">Instansi</div>
                </div>
              </div>
            </div>

            <div class="directory-search">
              <div class="search-icon">
                <v-icon size="20"> mdi-magnify </v-icon>
              </div>

              <v-text-field
                v-model="search"
                placeholder="Cari nama OPD atau instansi..."
                solo
                flat
                hide-details
                class="directory-search-input"
              />

              <div v-if="search" class="search-count">
                {{ filteredOpd.length }}
                ditemukan
              </div>
            </div>

            <div class="directory-result">
              <div>
                <span class="result-line"></span>

                <span>
                  {{ search ? "Hasil pencarian" : "Daftar seluruh instansi" }}
                </span>
              </div>

              <span class="result-count"> {{ filteredOpd.length }} OPD </span>
            </div>

            <div v-if="filteredOpd.length > 0" class="opd-grid">
              <article
                v-for="item in filteredOpd"
                :key="item.id"
                class="opd-card-modern"
                @click="goToMap(item)"
              >
                <div class="opd-photo">
                  <v-img
                    :src="
                      'https://berkah.bondowosokab.go.id:5500/uploads/' +
                      (item.foto || '/images/default-opd.png')
                    "
                    cover
                    height="100%"
                    width="100%"
                    alt="Foto OPD"
                  >
                    <template v-slot:placeholder>
                      <div class="image-loading">
                        <v-progress-circular indeterminate color="#018c74" size="22" />
                      </div>
                    </template>
                  </v-img>

                  <div class="photo-overlay"></div>

                  <div class="photo-location">
                    <v-icon size="13"> mdi-map-marker </v-icon>

                    <span> Lihat lokasi </span>
                  </div>
                </div>

                <div class="opd-card-content">
                  <div class="opd-card-top">
                    <div class="opd-type-icon">
                      <v-icon size="21" color="#018c74">
                        {{ getDynamicIcon(item.nama_opd) }}
                      </v-icon>
                    </div>

                    <div class="opd-official">
                      <v-icon size="13"> mdi-check-decagram </v-icon>

                      Bondowoso Berkah
                    </div>
                  </div>

                  <h3 class="opd-modern-name">
                    {{ item.nama_opd }}
                  </h3>

                  <p class="opd-modern-description">
                    {{
                      item.deskripsi ||
                      "Menyelenggarakan urusan pemerintahan di bidang terkait."
                    }}
                  </p>

                  <div class="opd-modern-footer">
                    <div class="social-list">
                      <template v-if="parseSosmed(item.sosmed).length > 0">
                        <v-tooltip
                          top
                          v-for="(soc, idx) in parseSosmed(item.sosmed)"
                          :key="idx"
                          color="#018c74"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              icon
                              x-small
                              class="social-modern-btn"
                              :style="{
                                color: getSosmedColor(soc.platform),
                              }"
                              :href="soc.url"
                              target="_blank"
                              @click.stop
                            >
                              <v-icon size="16">
                                {{ getSosmedIcon(soc.platform) }}
                              </v-icon>
                            </v-btn>
                          </template>

                          <span>
                            {{ soc.platform }}
                          </span>
                        </v-tooltip>
                      </template>

                      <span v-else class="no-social"> Tidak ada media sosial </span>
                    </div>

                  </div>
                </div>
              </article>
            </div>

            <div v-else class="empty-modern">
              <div class="empty-icon">
                <v-icon size="32"> mdi-office-building-search-outline </v-icon>
              </div>

              <h3>OPD Tidak Ditemukan</h3>

              <p>
                Tidak ada instansi yang sesuai dengan kata
                <strong> "{{ search }}" </strong>.
              </p>

              <v-btn text color="#018c74" @click="search = ''">
                <v-icon left> mdi-refresh </v-icon>

                Tampilkan Semua
              </v-btn>
            </div>
          </section>

          <div class="page-footer-modern">
            <span> BONDOWOSO BERKAH </span>

            <i></i>

            <span> DIREKTORI ORGANISASI PERANGKAT DAERAH </span>
          </div>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { getOpd } from "@/api/androidInitApi";

export default {
  name: "DaftarOpd",

  data: () => ({
    search: "",
    listOpd: [],
  }),

  computed: {
    filteredOpd() {
      if (!this.search) {
        return this.listOpd;
      }

      const keyword = this.search.toLowerCase().trim();

      return this.listOpd.filter((item) => {
        const nama = item.nama_opd ? item.nama_opd.toLowerCase() : "";

        const deskripsi = item.deskripsi ? item.deskripsi.toLowerCase() : "";

        return nama.includes(keyword) || deskripsi.includes(keyword);
      });
    },
  },

  mounted() {
    this.fetchData();
  },

  methods: {

    async fetchData() {
      try {
        this.listOpd = (await getOpd()) || [];
      } catch (e) {
        console.error("Gagal memuat data:", e);

        this.listOpd = [];
      }
    },


    parseSosmed(sosmedData) {
      if (!sosmedData) {
        return [];
      }

      if (typeof sosmedData === "string") {
        try {
          const parsed = JSON.parse(sosmedData);

          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }

      return Array.isArray(sosmedData) ? sosmedData : [];
    },

    getSosmedIcon(platform) {
      const icons = {
        facebook: "mdi-facebook",

        instagram: "mdi-instagram",

        youtube: "mdi-youtube",

        twitter: "mdi-twitter",

        tiktok: "mdi-music-note",

        website: "mdi-earth",

        whatsapp: "mdi-whatsapp",
      };

      const key = platform ? platform.toLowerCase() : "";

      return icons[key] || "mdi-link-variant";
    },

    getSosmedColor(platform) {
      const colors = {
        facebook: "#1877F2",

        instagram: "#E1306C",

        youtube: "#FF0000",

        twitter: "#1DA1F2",

        tiktok: "#000000",

        website: "#018c74",

        whatsapp: "#25D366",
      };

      const key = platform ? platform.toLowerCase() : "";

      return colors[key] || "#018c74";
    },


    getDynamicIcon(namaOpd) {
      const name = namaOpd ? namaOpd.toLowerCase() : "";

      if (name.includes("pendidikan")) {
        return "mdi-account-group";
      }

      if (name.includes("kesehatan")) {
        return "mdi-heart-pulse";
      }

      if (
        name.includes("pekerjaan umum") ||
        name.includes("tataruang") ||
        name.includes("tata ruang") ||
        name.includes("perkim")
      ) {
        return "mdi-road-variant";
      }

      if (name.includes("perdagangan") || name.includes("ekonomi")) {
        return "mdi-chart-bar";
      }

      if (name.includes("lingkungan")) {
        return "mdi-leaf";
      }

      if (name.includes("perhubungan")) {
        return "mdi-bus";
      }

      if (name.includes("kominfo") || name.includes("komunikasi")) {
        return "mdi-wifi";
      }

      if (name.includes("pertanian")) {
        return "mdi-sprout";
      }

      if (name.includes("peternakan")) {
        return "mdi-cow";
      }

      if (name.includes("pariwisata") || name.includes("kebudayaan")) {
        return "mdi-camera-image";
      }

      if (name.includes("pemuda") || name.includes("olahraga")) {
        return "mdi-run";
      }

      if (name.includes("keuangan") || name.includes("pendapatan")) {
        return "mdi-cash-multiple";
      }

      if (name.includes("kependudukan") || name.includes("catatan sipil")) {
        return "mdi-account-card-details";
      }

      if (name.includes("sosial")) {
        return "mdi-hand-heart";
      }

      if (name.includes("tenaga kerja") || name.includes("ketenagakerjaan")) {
        return "mdi-account-hard-hat";
      }

      if (name.includes("perpustakaan")) {
        return "mdi-bookshelf";
      }

      if (name.includes("arsip")) {
        return "mdi-archive";
      }

      if (name.includes("hukum")) {
        return "mdi-scale-balance";
      }

      if (name.includes("inspektorat")) {
        return "mdi-shield-check";
      }

      if (name.includes("sekretariat")) {
        return "mdi-office-building";
      }

      return "mdi-office-building";
    },


    goToMap(item) {
      if (!item.latlong) {
        alert("Koordinat lokasi tidak tersedia untuk instansi ini.");

        return;
      }

      this.$router.push({
        name: "peta",

        query: {
          name: item.nama_opd,

          latlong: item.latlong,

          addr: item.alamat_kantor,
        },
      });
    },
  },
};
</script>

<style scoped>

.opd-app {
  --teal: #018c74;
  --teal-dark: #006b5b;
  --teal-deep: #07584d;
  --teal-soft: #eaf7f4;

  --gold: #cfa22d;
  --gold-soft: #fff7df;

  --text: #18332f;
  --text-soft: #71817e;
  --muted: #9aa8a5;

  --background: #f4f8f7;

  --white: #ffffff;

  background: #f4f8f7 !important;
}

.v-application--wrap {
  background: transparent !important;
}


.main-area {
  min-height: 100vh;

  background: radial-gradient(circle at 8% 8%, rgba(1, 140, 116, 0.08), transparent 22%),
    radial-gradient(circle at 94% 28%, rgba(207, 162, 45, 0.06), transparent 20%), #f4f8f7 !important;
}

.main-container {
  position: relative;

  z-index: 2;

  padding: 34px 24px 60px !important;
}

.content-wrapper {
  width: 100%;

  max-width: 1220px;

  margin: 0 auto;
}


.directory-hero {
  position: relative;

  min-height: 285px;

  display: flex;

  align-items: center;

  justify-content: space-between;

  overflow: hidden;

  margin-bottom: 24px;

  padding: 38px 44px;

  border-radius: 26px;

  background: linear-gradient(125deg, #07584d 0%, #018c74 58%, #0a9b82 100%);

  box-shadow: 0 22px 55px rgba(0, 91, 77, 0.16);
}

.directory-hero::before {
  content: "";

  position: absolute;

  inset: 0;

  background-image: radial-gradient(rgba(255, 255, 255, 0.13) 1px, transparent 1px);

  background-size: 22px 22px;

  opacity: 0.3;
}


.hero-content {
  position: relative;

  z-index: 3;

  max-width: 650px;
}

.hero-eyebrow {
  display: flex;

  align-items: center;

  gap: 8px;

  margin-bottom: 12px;

  color: rgba(255, 255, 255, 0.75);

  font-size: 10px;

  font-weight: 800;

  letter-spacing: 1.8px;
}

.hero-dot {
  width: 26px;

  height: 3px;

  border-radius: 10px;

  background: #e2bd54;
}

.hero-title {
  margin: 0;

  color: white;

  font-size: clamp(2.4rem, 5vw, 4rem);

  line-height: 1;

  font-weight: 900;

  letter-spacing: -2px;
}

.hero-title span {
  color: #e8c75e;
}

.hero-description {
  max-width: 590px;

  margin: 14px 0 22px;

  color: rgba(255, 255, 255, 0.76);

  font-size: 0.88rem;

  line-height: 1.7;
}


.hero-actions {
  display: flex;

  align-items: center;

  gap: 10px;
}

.hero-mini-stat {
  display: flex;

  align-items: center;

  gap: 10px;

  padding: 9px 13px;

  border-radius: 13px;

  background: rgba(255, 255, 255, 0.12);

  border: 1px solid rgba(255, 255, 255, 0.14);

  backdrop-filter: blur(10px);
}

.mini-stat-icon {
  width: 32px;

  height: 32px;

  display: flex;

  align-items: center;

  justify-content: center;

  border-radius: 9px;

  color: white;

  background: rgba(255, 255, 255, 0.15);
}

.mini-stat-icon.gold {
  color: #f3d36b;
}

.hero-mini-stat strong {
  display: block;

  color: white;

  font-size: 0.9rem;

  line-height: 1.1;
}

.hero-mini-stat span {
  display: block;

  margin-top: 2px;

  color: rgba(255, 255, 255, 0.6);

  font-size: 0.58rem;
}


.hero-visual {
  position: relative;

  width: 300px;

  height: 230px;

  flex-shrink: 0;
}

.visual-circle {
  position: absolute;

  border-radius: 50%;

  border: 1px solid rgba(255, 255, 255, 0.13);
}

.circle-1 {
  width: 230px;

  height: 230px;

  right: 10px;

  top: 0;
}

.circle-2 {
  width: 165px;

  height: 165px;

  right: 43px;

  top: 32px;

  background: rgba(255, 255, 255, 0.04);
}

.visual-building {
  position: absolute;

  top: 65px;

  right: 90px;

  width: 95px;

  height: 95px;

  display: flex;

  align-items: center;

  justify-content: center;

  border-radius: 28px;

  color: white;

  background: rgba(255, 255, 255, 0.11);

  border: 1px solid rgba(255, 255, 255, 0.16);

  backdrop-filter: blur(15px);

  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
}

.visual-floating-card {
  position: absolute;

  display: flex;

  align-items: center;

  gap: 7px;

  padding: 8px 11px;

  border-radius: 10px;

  background: white;

  color: #31564f;

  font-size: 9px;

  font-weight: 800;

  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.12);
}

.card-top {
  top: 35px;

  right: 0;
}

.card-bottom {
  right: 25px;

  bottom: 25px;
}


.directory-container {
  padding: 25px;

  border-radius: 25px;

  background: rgba(255, 255, 255, 0.92);

  border: 1px solid rgba(1, 140, 116, 0.08);

  box-shadow: 0 18px 55px rgba(25, 75, 68, 0.07);
}


.directory-toolbar {
  display: flex;

  align-items: center;

  justify-content: space-between;

  gap: 20px;

  margin-bottom: 22px;
}

.toolbar-heading {
  display: flex;

  align-items: center;

  gap: 13px;
}

.toolbar-icon {
  width: 45px;

  height: 45px;

  display: flex;

  align-items: center;

  justify-content: center;

  flex-shrink: 0;

  border-radius: 13px;

  color: var(--teal);

  background: var(--teal-soft);
}

.toolbar-kicker {
  color: var(--teal);

  font-size: 9px;

  font-weight: 900;

  letter-spacing: 1.4px;
}

.toolbar-heading h2 {
  margin: 3px 0 2px;

  color: var(--text);

  font-size: 1.4rem;

  font-weight: 900;

  letter-spacing: -0.5px;
}

.toolbar-heading p {
  margin: 0;

  color: var(--text-soft);

  font-size: 0.67rem;
}


.toolbar-total {
  display: flex;

  align-items: center;

  gap: 10px;

  padding: 9px 13px;

  border-radius: 13px;

  background: #f7faf9;

  border: 1px solid rgba(1, 140, 116, 0.08);
}

.toolbar-total-number {
  color: var(--teal);

  font-size: 1.3rem;

  font-weight: 900;
}

.toolbar-total-label {
  color: #9aa8a5;

  font-size: 8px;

  font-weight: 900;

  letter-spacing: 1px;
}

.toolbar-total-text {
  color: var(--text);

  font-size: 10px;

  font-weight: 700;
}


.directory-search {
  display: flex;

  align-items: center;

  min-height: 50px;

  padding: 0 8px;

  border-radius: 14px;

  background: #f5f9f8;

  border: 1px solid rgba(1, 140, 116, 0.1);

  transition: 0.2s ease;
}

.directory-search:focus-within {
  background: white;

  border-color: rgba(1, 140, 116, 0.4);

  box-shadow: 0 8px 25px rgba(1, 140, 116, 0.07);
}

.search-icon {
  width: 40px;

  display: flex;

  align-items: center;

  justify-content: center;

  color: var(--teal);
}

.directory-search-input {
  flex: 1;
}

.directory-search-input::v-deep .v-input__slot {
  min-height: 48px !important;

  margin: 0 !important;

  padding: 0 !important;

  background: transparent !important;

  box-shadow: none !important;
}

.directory-search-input::v-deep input {
  color: var(--text) !important;

  font-size: 0.78rem !important;
}

.directory-search-input::v-deep input::placeholder {
  color: #9aa8a5 !important;
}

.search-count {
  margin-right: 8px;

  padding: 5px 9px;

  border-radius: 7px;

  color: var(--teal);

  background: var(--teal-soft);

  font-size: 9px;

  font-weight: 800;
}


.directory-result {
  display: flex;

  align-items: center;

  justify-content: space-between;

  margin: 18px 2px 12px;

  color: #84928f;

  font-size: 9px;

  font-weight: 700;
}

.directory-result > div {
  display: flex;

  align-items: center;

  gap: 7px;
}

.result-line {
  width: 17px;

  height: 2px;

  border-radius: 5px;

  background: var(--gold);
}

.result-count {
  color: var(--teal);

  font-weight: 900;
}


.opd-grid {
  display: grid;

  grid-template-columns: repeat(2, minmax(0, 1fr));

  gap: 12px;
}


.opd-card-modern {
  position: relative;

  display: flex;

  min-width: 0;

  overflow: hidden;

  min-height: 165px;

  border-radius: 17px;

  background: white;

  border: 1px solid rgba(20, 75, 70, 0.08);

  cursor: pointer;

  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
}

.opd-card-modern:hover {
  transform: translateY(-3px);

  border-color: rgba(1, 140, 116, 0.25);

  box-shadow: 0 15px 35px rgba(30, 80, 75, 0.1);
}


.opd-photo {
  position: relative;

  width: 155px;

  min-width: 155px;

  overflow: hidden;

  background: #edf4f2;
}

.opd-photo .v-image {
  transition: transform 0.4s ease;
}

.opd-card-modern:hover .opd-photo .v-image {
  transform: scale(1.04);
}

.photo-overlay {
  position: absolute;

  inset: 0;

  background: linear-gradient(180deg, transparent 50%, rgba(0, 50, 42, 0.55));
}

.photo-location {
  position: absolute;

  left: 10px;

  bottom: 9px;

  display: flex;

  align-items: center;

  gap: 4px;

  color: white;

  font-size: 8px;

  font-weight: 800;

  opacity: 0;

  transform: translateY(4px);

  transition: 0.2s ease;
}

.opd-card-modern:hover .photo-location {
  opacity: 1;

  transform: translateY(0);
}

.image-loading {
  width: 100%;

  height: 100%;

  display: flex;

  align-items: center;

  justify-content: center;

  background: #edf4f2;
}


.opd-card-content {
  min-width: 0;

  flex: 1;

  display: flex;

  flex-direction: column;

  padding: 15px 16px 13px;
}

.opd-card-top {
  display: flex;

  align-items: center;

  justify-content: space-between;

  gap: 7px;
}

.opd-type-icon {
  width: 35px;

  height: 35px;

  display: flex;

  align-items: center;

  justify-content: center;

  border-radius: 10px;

  background: var(--teal-soft);
}

.opd-official {
  display: flex;

  align-items: center;

  gap: 4px;

  color: #8c9996;

  font-size: 7px;

  font-weight: 700;
}

.opd-official .v-icon {
  color: var(--teal);
}


.opd-modern-name {
  margin: 12px 0 5px;

  color: var(--text);

  font-size: 0.82rem;

  line-height: 1.35;

  font-weight: 900;
}

.opd-modern-description {
  margin: 0;

  color: var(--text-soft);

  font-size: 0.66rem;

  line-height: 1.55;

  display: -webkit-box;

  -webkit-line-clamp: 2;

  -webkit-box-orient: vertical;

  overflow: hidden;
}


.opd-modern-footer {
  display: flex;

  align-items: center;

  justify-content: space-between;

  gap: 8px;

  margin-top: auto;

  padding-top: 10px;
}

.social-list {
  display: flex;

  align-items: center;

  gap: 2px;
}

.social-modern-btn {
  width: 27px !important;

  height: 27px !important;

  background: #f4f7f6;
}

.social-modern-btn:hover {
  background: white !important;

  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.no-social {
  color: #a6b0ad;

  font-size: 7px;

  font-style: italic;
}

.opd-open {
  display: flex;

  align-items: center;

  gap: 3px;

  color: var(--teal);

  font-size: 8px;

  font-weight: 900;
}

.opd-open .v-icon {
  transition: transform 0.2s ease;
}

.opd-card-modern:hover .opd-open .v-icon {
  transform: translateX(3px);
}


.empty-modern {
  padding: 70px 20px;

  text-align: center;
}

.empty-icon {
  width: 65px;

  height: 65px;

  display: flex;

  align-items: center;

  justify-content: center;

  margin: 0 auto 14px;

  border-radius: 18px;

  color: var(--teal);

  background: var(--teal-soft);
}

.empty-modern h3 {
  margin: 0;

  color: var(--text);

  font-size: 1rem;

  font-weight: 900;
}

.empty-modern p {
  margin: 6px 0 14px;

  color: var(--text-soft);

  font-size: 0.72rem;
}


.page-footer-modern {
  display: flex;

  align-items: center;

  justify-content: center;

  gap: 9px;

  margin-top: 25px;

  color: #9aa7a4;

  font-size: 7px;

  font-weight: 800;

  letter-spacing: 1.2px;
}

.page-footer-modern i {
  width: 4px;

  height: 4px;

  border-radius: 50%;

  background: var(--gold);
}


.layanan-header {
  background: rgba(255, 255, 255, 0.94) !important;

  backdrop-filter: blur(18px);

  border-bottom: 1px solid rgba(1, 140, 116, 0.08) !important;

  z-index: 20 !important;
}

.header-inner {
  width: 100%;

  max-width: 1280px;

  margin: 0 auto;

  display: flex;

  align-items: center;
}

.back-btn {
  width: 42px !important;

  height: 42px !important;

  background: #f1f6f5;

  margin-right: 10px;
}

.back-btn:hover {
  background: #e8f5f2;
}

.header-brand {
  display: flex;

  align-items: center;

  gap: 10px;
}

.brand-mark {
  width: 40px;

  height: 40px;

  display: flex;

  align-items: center;

  justify-content: center;

  border-radius: 12px;

  background: linear-gradient(135deg, #e4f6f1, #f5fbf9);

  border: 1px solid rgba(1, 140, 116, 0.1);
}

.brand-name {
  font-size: 15px;

  font-weight: 900;

  letter-spacing: 0.5px;

  color: #17423b;

  line-height: 1.1;
}

.brand-name span {
  color: #018c74;
}

.brand-tagline {
  font-size: 9px;

  color: #8a969b;

  margin-top: 3px;
}

.header-info {
  display: flex;

  align-items: center;

  gap: 9px;

  min-width: 0;
}

.header-info > div:last-child {
  min-width: 0;
}

.header-info-icon {
  width: 36px;

  height: 36px;

  border-radius: 10px;

  background: #f1faf8;

  display: flex;

  align-items: center;

  justify-content: center;
}

.header-info-title {
  font-size: 12px;

  font-weight: 800;

  color: #34514c;
}

.header-info-subtitle {
  max-width: 260px;

  font-size: 10px;

  color: #929da1;

  margin-top: 1px;

  white-space: nowrap;

  overflow: hidden;

  text-overflow: ellipsis;
}


@media (max-width: 1000px) {
  .directory-hero {
    padding: 32px;
  }

  .hero-visual {
    width: 240px;
  }

  .visual-building {
    right: 65px;
  }

  .opd-photo {
    width: 135px;

    min-width: 135px;
  }
}


@media (max-width: 768px) {
  .main-container {
    padding: 18px 10px 40px !important;
  }


  .directory-hero {
    min-height: auto;

    display: block;

    padding: 25px 22px;

    border-radius: 21px;
  }

  .hero-title {
    font-size: 2.25rem;

    letter-spacing: -1.4px;
  }

  .hero-description {
    font-size: 0.72rem;

    line-height: 1.55;

    margin: 11px 0 17px;
  }

  .hero-actions {
    flex-wrap: wrap;
  }

  .hero-mini-stat {
    padding: 7px 10px;
  }

  .hero-visual {
    display: none;
  }


  .directory-container {
    padding: 14px;

    border-radius: 19px;
  }

  .directory-toolbar {
    align-items: flex-start;
  }

  .toolbar-icon {
    width: 39px;

    height: 39px;
  }

  .toolbar-heading h2 {
    font-size: 1.15rem;
  }

  .toolbar-heading p {
    font-size: 0.6rem;
  }

  .toolbar-total {
    padding: 7px 9px;
  }

  .toolbar-total-number {
    font-size: 1.05rem;
  }

  .toolbar-total-label {
    font-size: 7px;
  }

  .toolbar-total-text {
    font-size: 8px;
  }


  .directory-search {
    min-height: 45px;
  }

  .directory-search-input::v-deep .v-input__slot {
    min-height: 43px !important;
  }

  .directory-search-input::v-deep input {
    font-size: 0.7rem !important;
  }

  .search-count {
    display: none;
  }


  .opd-grid {
    grid-template-columns: 1fr;

    gap: 9px;
  }


  .opd-card-modern {
    min-height: 140px;
  }

  .opd-photo {
    width: 115px;

    min-width: 115px;
  }

  .opd-card-content {
    padding: 12px;
  }

  .opd-type-icon {
    width: 31px;

    height: 31px;
  }

  .opd-official {
    font-size: 6px;
  }

  .opd-modern-name {
    margin-top: 9px;

    font-size: 0.75rem;
  }

  .opd-modern-description {
    font-size: 0.61rem;
  }

  .opd-open span {
    display: none;
  }

  .photo-location {
    opacity: 1;

    transform: none;
  }


  .page-footer-modern {
    font-size: 6px;
  }
}


@media (max-width: 430px) {
  .header-inner {
    padding: 0 8px;
  }

  .brand-mark {
    width: 35px;

    height: 35px;
  }

  .brand-mark img {
    width: 34px;
  }

  .brand-name {
    font-size: 12px;
  }

  .brand-tagline {
    font-size: 8px;
  }

  .directory-hero {
    padding: 22px 18px;
  }

  .hero-eyebrow {
    font-size: 8px;

    letter-spacing: 1.1px;
  }

  .hero-title {
    font-size: 2rem;
  }

  .hero-description {
    font-size: 0.66rem;
  }

  .hero-mini-stat {
    flex: 1;
  }

  .directory-toolbar {
    gap: 8px;
  }

  .toolbar-heading p {
    display: none;
  }

  .toolbar-total {
    flex-shrink: 0;
  }

  .opd-photo {
    width: 100px;

    min-width: 100px;
  }

  .opd-modern-name {
    font-size: 0.7rem;
  }

  .opd-modern-description {
    font-size: 0.58rem;
  }
}


@media (prefers-reduced-motion: reduce) {
  .opd-card-modern,
  .opd-photo .v-image,
  .opd-open .v-icon,
  .photo-location {
    transition: none !important;
  }
}
</style>
